import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import TYPES from '../../../config/Types'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import { IStatement } from '../../../model/statement'
import { Meta } from '../../../model/meta'

export default async function fetchTags(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.getTags(statement).then((tags: Meta<string[]>) => {
        statementStore.commitSetTags({ statement: statement, tags: tags.value })
    })

    return
}
